import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { IonBottomDrawerComponent } from './ion-bottom-drawer.component';

@NgModule({
  declarations: [IonBottomDrawerComponent],
  imports: [IonicModule],
  exports: [IonBottomDrawerComponent],
})
export class IonBottomDrawerModule {}
